// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalCrop_modal__3IBcE","modal_content":"ModalCrop_modal_content__1ALpB"};